import { render, staticRenderFns } from "./LoadingPlaceholder.vue?vue&type=template&id=49cc6b33&scoped=true&"
import script from "./LoadingPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./LoadingPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingPlaceholder.vue?vue&type=style&index=0&id=49cc6b33&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cc6b33",
  null
  
)

export default component.exports